import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import { ButtonStyles } from "../../constants/ButtonStyles";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function InvestorsDetailBody({ data, onBack }) {
  const formatDate = (cell) => {
    if (!cell) return "";
    const d = new Date(cell);
    if (isNaN(d)) return cell;
    return new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(d); // e.g. "Oct 1, 2025"
  };

  return (
    <div>
      <Card style={{
        borderRadius: "15px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
        border: "none",
        overflow: "hidden"
      }}>
        <CardHeader style={{
          background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
          padding: "15px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "none"
        }}>
          <strong style={{ color: "#fff", fontSize: "18px" }}>
            <i className="fa fa-list" style={{ marginRight: "10px" }}></i>
            Transaction Details
          </strong>
          <Button
            style={ButtonStyles.secondary}
            onClick={() => onBack()}
          >
            <i className="fa fa-arrow-left" style={{ marginRight: "8px" }} />
            Back
          </Button>
        </CardHeader>
        <CardBody style={{ padding: "25px" }}>
          <BootstrapTable
            data={data}
            version="4"
            condensed={true}
            striped
            hover
            pagination
            search
            options={options}
            exportCSV
            csvFileName="Bank_account_details.csv"
          >
            <TableHeaderColumn
              isKey
              dataField="id"
              export={false}
              hidden={true}
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="transactionDate"
              csvHeader="date"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              dataFormat={formatDate}
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="transactionAmount"
              csvHeader="transactionAmount"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Amount
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="type"
              csvHeader="type"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Type
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="transactionCategory"
              csvHeader="transactionCategory"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Category
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="description"
              csvHeader="description"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Description
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="updatedBy"
              csvHeader="Updated By"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Update By
            </TableHeaderColumn>
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/InvestorsDetailBody.js